<template>
  <div class="custom-table-bd tb">
    <div class="search-hd" style="width: calc(100% + 8px)">
      <el-form :inline="true" @submit.native.prevent>
        <el-form-item>
          <slot name="header"></slot>
        </el-form-item>
        <el-form-item style="float: right" v-if="searchView.includes('export')">
          <el-button class="table-set">
            <i class="icon icon-daochu"></i>
          </el-button>
        </el-form-item>
        <el-form-item style="float: right" v-if="searchView.includes('column')">
          <custom-column ref="column"></custom-column>
        </el-form-item>
        <el-form-item style="float: right" v-if="searchView.includes('keyword')">
          <search-input v-model="form.keyword" :placeholder="searchPlaceholder" @fetch="onPageChange({ page: 1 })"></search-input>
        </el-form-item>
        <el-form-item style="float: right" v-if="searchView.includes('search')">
          <search-input v-model="form.search" :placeholder="searchPlaceholder" @fetch="onPageChange({ page: 1 })"></search-input>
        </el-form-item>
        <el-form-item style="float: right" v-if="slots.includes('switch')">
          <switch-button :link="$refs.container"></switch-button>
        </el-form-item>
        <el-form-item style="float: right">
          <slot name="header-right"></slot>
        </el-form-item>
      </el-form>
    </div>
    <switch-container v-if="slots.includes('switch')" ref="container" @search="onPageChange({ page: 1 })" @clear="onClear">
      <slot name="switch"></slot>
    </switch-container>
    <div class="table-bd">
      <el-table
        ref="tb1"
        size="mini"
        :data="dataList"
        :row-key="rowKey"
        :expand-row-keys="expandRowKeys"
        :highlight-current-row="radio"
        :empty-text="!data ? ' ' : $t('Common.com_no_data')"
        @header-dragend="onHeaderDrag"
        @current-change="onSelectChange('radio', $event)"
        @selection-change="onSelectChange('checkbox', $event)"
        @sort-change="onSortChange"
        @filter-change="onFilterChange"
        @row-click="onRowClick($event, 'tb1')"
        :class="{ 'border-right': boderRight }"
        :show-summary="showSummary"
        :summary-method="summaryMethod"
        :row-class-name="rowClassName"
        v-bind="$attrs"
        v-on="$listeners"
        v-loading="!data"
        :border="border"
        height="100%"
      >
        <el-table-column v-if="expand && columnList.length > 1" type="expand">
          <template slot-scope="scope">
            <slot
              name="expand"
              v-bind="{
                $index: scope.$index,
                row: scope.row,
                column: scope.column,
              }"
            ></slot>
          </template>
        </el-table-column>
        <el-table-column v-if="index && columnList.length > 1" type="index" width="44" fixed="left" label="#"></el-table-column>
        <el-table-column v-if="checkbox && columnList.length > 1" type="selection" width="44" fixed="left" :selectable="onSelectable"></el-table-column>
        <!-- 配置列 -->
        <template v-for="(item, index) in columnList">
          <el-table-column
            :key="index"
            :index="index"
            :prop="item.columnCode"
            :label="item.columnName"
            :min-width="item.width"
            :sortable="item.isSort && isFilter ? 'custom' : false"
            :fixed="item.isFixed ? 'right' : null"
            :column-key="item.columnCode"
            :filter-multiple="true"
            :filters="isFilter ? item.filters : undefined"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <slot
                v-if="slots.includes(item.columnCode)"
                :name="item.columnCode"
                v-bind="{
                  $index: scope.$index,
                  row: scope.row,
                  column: scope.column,
                }"
              ></slot>
              <span v-else>{{ formatter(scope.row, scope.column) }}</span>
            </template>
          </el-table-column>
        </template>
      </el-table>
    </div>
    <div class="table-page" v-if="total && form.pageSize">
      <custom-page :total="total" :page="form.pageNum" :size="form.pageSize" @change="onPageChange"></custom-page>
    </div>
    <slot></slot>
  </div>
</template>

<script>
import apis from '@/utils/apis';

export default {
  props: {
    searchView: { type: String, default: 'search,column' }, // column,export,keyword,search
    searchPlaceholder: String, // 搜索框文字
    width: String, // 操作宽度
    form: Object, // 参数
    total: Number, // 总数
    rowKey: [String, Function],
    expandRowKeys: Array,
    columnRef: String, // 配置列Ref
    value: [Array, Object], // 绑定值
    tableCode: String, // 表格编码
    column: Array, // 表格列
    data: Array, // 表格数据
    index: Boolean, // 行数
    radio: Boolean, // 单选
    checkbox: Boolean, // 多选
    onlyArr: Array, // 保留表格列code数组（优先级高于filterArr）
    filterArr: Array, // 过滤表格列code数组
    isFilter: { type: Boolean, default: true }, // 是否启用sort和filter
    selectableKey: { type: String, default: 'isExists' }, // 禁用选择框code
    clickSelection: Boolean, // 点击是否选中该行（toggleRowSelection）
    expand: { type: Boolean, default: false },
    showSummary: { type: Boolean, default: false },
    border: { type: Boolean, default: true },
    boderRight: { type: Boolean, default: false },
    summaryMethod: { type: Function },
    rowClassName: { type: Function },
  },
  created() {
    this.$on('clearFilter', (columnKey) => {
      setTimeout(() => {
        this.$nextTick(() => {
          this.$refs.tb1.clearFilter(columnKey);
        });
      }, 300);
    });
    this.$on('toggleRowSelection', (item, value) => {
      setTimeout(() => {
        this.$nextTick(() => {
          this.$refs.tb1.toggleRowSelection(item, value);
        });
      }, 300);
    });
    this.$on('clearSelection', () => {
      setTimeout(() => {
        this.$nextTick(() => {
          this.$refs.tb1.clearSelection();
        });
      }, 300);
    });
    this.$on('setCurrentRow', (row) => {
      setTimeout(() => {
        this.$nextTick(() => {
          this.$refs.tb1.setCurrentRow(row);
        });
      }, 300);
    });
  },
  watch: {
    tableCode() {
      this.tableColumn = [];
      this.getTableColumn();
    },
    column: {
      handler: function () {
        this.tableColumn = [];
        this.getTableColumn();
      },
    },
  },
  computed: {
    slots: vm => Object.keys(vm.$scopedSlots),
    dataList: vm => (vm.columnList.length > 1 ? vm.data : []),
    columnList(vm) {
      let list = vm.tableCode ? vm.tableColumn : vm.column;
      if (!list.length) {
        return [{ columnCode: 'empty', columnName: '' }];
      }
      if (vm.slots.includes('action')) {
        list = [
          ...list,
          {
            columnCode: 'action',
            columnName: this.$t('Common.com_handle'),
            selected: true,
            isFixed: true,
            width: vm.width || '160',
          },
        ];
      }
      if (vm.onlyArr && vm.onlyArr.length) {
        list = list.filter(col => vm.onlyArr.includes(col.columnCode));
      }
      if (vm.filterArr && vm.filterArr.length) {
        list = list.filter(t => !vm.filterArr.includes(t.columnCode));
      }
      return list.filter(t => t.selected);
    },
  },
  data() {
    return {
      tableColumn: [],
      columnDictionary: {},
    };
  },
  mounted() {
    this.initTableValue();
    this.getTableColumn();
  },
  methods: {
    // 表格重新布局
    doLayout: function () {
      this.$nextTick(() => {
        if (this.$refs.tb1) {
          this.$refs.tb1.doLayout();
        }
      });
    },
    // 初始选中
    initTableValue: function () {
      if (this.radio && this.value) {
        setTimeout(() => {
          this.$nextTick(() => {
            this.$refs.tb1.setCurrentRow(this.value);
          });
        }, 300);
      }
      if (this.checkbox && this.value) {
        setTimeout(() => {
          this.value.forEach((row) => {
            this.$refs.tb1.toggleRowSelection(row, true);
          });
        });
      }
    },
    // 获取表格列
    getTableColumn: function () {
      if (!this.tableCode) {
        return;
      }
      this.$getJSON(apis.TableColumnGet, { tableCode: this.tableCode }).then((res) => {
        const tableColumn = res.data || [];
        // 获取字典
        const codes = tableColumn.filter(t => t.isFormat && t.formatRule === 'dic_group').map(f => f.dicGroup);
        const hasDate = tableColumn.find(t => t.formatRule === 'tableField_date');
        if (hasDate) {
          codes.push('bas_tableField_dateFormat');
        }
        if (codes.length) {
          this.getDictionary(
            codes.join(','),
            (dictionary) => {
              tableColumn.forEach((item) => {
                // 多选表格列过滤
                if (item.isFormat && item.formatRule === 'dic_group' && item.checkbox) {
                  const propList = dictionary[item.dicGroup].map(t => ({ text: t.name, value: t.value, code: t.code }));
                  const rules = item.checkboxRule && item.checkboxRule.split(',');
                  item.filters = item.checkboxRule ? propList.filter(t => rules.includes(t.code)) : propList;
                }
              });
              this.tableColumn = tableColumn;
              this.$nextTick(() => {
                // this.$emit('column', { tableCode: this.tableCode, tableColumn, columnRef: this.columnRef });
                const column = this.$refs.column;
                if (column) {
                  column.tableCode = this.tableCode;
                  column.tableColumn = tableColumn;
                  column.formatTable();
                }
              });
              this.doLayout();
            },
            'columnDictionary'
          );
        } else {
          this.tableColumn = tableColumn;
          this.$nextTick(() => {
            // this.$emit('column', { tableCode: this.tableCode, tableColumn, columnRef: this.columnRef });
            const column = this.$refs.column;
            if (column) {
              column.tableCode = this.tableCode;
              column.tableColumn = tableColumn;
              column.formatTable();
            }
          });
          this.doLayout();
        }
      });
    },
    // 格式化表格列
    formatter: function (row, col) {
      const column = this.columnList[col.index];
      if (column.isFormat) {
        const dictionary = this.tableCode ? this.columnDictionary : this.$store.state.dictionary;
        let result = '';
        // 格式化字典
        if (column.formatRule === 'dic_group' && column.dicGroup) {
          const group = this.$transformDicValue(dictionary[column.dicGroup]);
          const value = row[col.property];
          result = group[`${value}`] || value || '-';
        }
        // 格式化日期
        if (column.formatRule === 'tableField_date' && column.dicGroup) {
          const group = this.$transformDicCode(dictionary.bas_tableField_dateFormat);
          const param = group[column.dicGroup];
          try {
            if (row[col.property]) {
              if (param !== 'formatSecToHm' && param !== 'toFixed') {
                result = this.$momentLocal(row[col.property], param);
              } else if (param === 'formatSecToHm') {
                // formatSecToHm
                // 特殊处理时间 h:m
                result = this[`$${param}`](row[col.property]);
              } else if (param === 'toFixed') {
                // toFixed 数据保留两位小数特殊处理
                result = this[`$${param}`](row[col.property]);
              }
            }
            if (param === 'formatSecToHm') {
              // formatSecToHm 以Format字段结尾的
              // 特殊处理时间 h:m
              const field = col.property.replace('Format', '');
              result = this[`$${param}`](row[field]);
            }
            if (param === 'toFixed') {
              // toFixed 数据保留两位小数特殊处理
              result = this[`$${param}`](row[col.property]);
            }
          } catch (e) {
            //
          }
        }
        return result === undefined || result === '' ? '-' : result;
      } else {
        const value = row[col.property];
        return value === undefined || value === '' ? '-' : value;
      }
    },
    // 单选多选
    onSelectChange(type, value) {
      this.$emit('input', value || {});
      this.$emit('change', value || {});
      this.$emit(type, value || {});
    },
    // 选中行
    onRowClick(row, name) {
      if (this.clickSelection) {
        if (row.isExists) {
          return;
        }
        this.$refs[name].toggleRowSelection(row);
      }
      this.$emit('row-click', row);
      this.$emit('on-row-click', row);
    },
    // 表格禁用行
    onSelectable: function (row) {
      return !row[this.selectableKey];
    },
    // 多选
    onFilterChange: function (value) {
      const formSearch = Object.assign(this.form, value, { pageNum: 1 });
      this.$emit('page', formSearch);
    },
    // 排序
    onSortChange: function ({ prop, order }) {
      const value = { orderBy: prop };
      if (order) {
        value.orderType = order === 'ascending' ? 'asc' : 'desc';
      } else {
        value.orderType = '';
        value.orderBy = '';
      }
      const formSearch = Object.assign(this.form, value, { pageNum: 1 });
      this.$emit('page', formSearch);
    },
    // 分页
    onPageChange: function ({ size, page }) {
      const formSearch = Object.assign(this.form, { pageSize: size || this.form.pageSize, pageNum: page });
      this.$emit('page', formSearch);
    },
    // 清空
    onClear() {
      this.$emit('clear');
    },
    // 列宽
    onHeaderDrag: function (newWidth, oldWidth, column) {
      const isrDrag = localStorage.headerDrag;
      if (!isrDrag) {
        return;
      }
      const col = this.columnList[column.index];
      this.$postJSON(apis.TableColUpdate, {
        columnId: col.columnId,
        width: newWidth,
      }).then(() => {});
    },
  },
};
</script>
<style lang="scss">
.el-table--group,
.el-table--border {
  border: none !important;
}
.el-table--group::after,
.el-table--border::after {
  display: none;
}

.el-table--border th,
.el-table--border td {
  border-right: none !important;
}

// 带左右边框
.el-table.border-right::before {
  // display: 1px solid #eef2f8;
  height: 0;
}
.border-right .el-table__fixed::before,
.border-right .el-table__fixed-right::before {
  height: 0;
}
.el-table--border.border-right th,
.el-table--border.border-right td {
  border-right: 1px solid #eef2f8 !important;
}
.el-table--border.border-right th:first-child,
.el-table--border.border-right td:first-child {
  border-left: 1px solid #eef2f8 !important;
}

.custom-table {
  $formElHeight: 28px;
  .el-input__inner {
    height: $formElHeight !important;
    line-height: $formElHeight !important;
    padding-left: 8px;
  }
  .el-input__icon {
    line-height: $formElHeight !important;
  }
  .el-input__suffix {
    right: 0;
  }
}
</style>
